import { jwtDecode } from 'jwt-decode'

export function parseJwtToken<SessionType>(token: string) {
  return jwtDecode(token) as SessionType
}